import i18n from "@/i18n";
import { ISorter } from "@/models/tables";

const affiliateLinksSorters: ISorter[] = [
  {
    field: "created_at",
    label: i18n.t("_.date_created")
  },
  {
    field: "visit_count",
    label: i18n.t("_.visits")
  },
  {
    field: "referral_count",
    label: i18n.t("_.referrals")
  }
];

const affiliateTiersSorters: ISorter[] = [
  {
    field: "created_at",
    label: i18n.t("_.date_created")
  },
  {
    field: "name",
    label: i18n.t("_.name")
  }
];

const affiliatePayoutDestinationSorters: ISorter[] = [
  {
    field: "created_at",
    label: i18n.t("_.date_created")
  },
  {
    field: "name",
    label: i18n.t("_.name")
  }
];

const AffiliateCommissionsSorters: ISorter[] = [
  {
    field: "amount",
    label: i18n.t("_.amount")
  },
  {
    field: "created_at",
    label: i18n.t("_.date_created")
  }
];

const AffiliatePayoutSorters: ISorter[] = [
  {
    field: "amount",
    label: i18n.t("_.amount")
  },
  {
    field: "created_at",
    label: i18n.t("_.date_paid")
  }
];

export {
  affiliateLinksSorters,
  affiliateTiersSorters,
  affiliatePayoutDestinationSorters,
  AffiliateCommissionsSorters,
  AffiliatePayoutSorters
};
